<template>
  <v-col class="vuse-content-wrapper">
    <vuse-section-definition
        :breadcrumbs="breadcrumbs"
        :title="page"
        icon="mdi-file-document"
    ></vuse-section-definition>
    <v-container class=" p-5" fluid>
      <v-row class="white mr-4 rounded-lg">
        <v-col cols="12">
          <v-row>
            <v-col cols="6">
              <v-col cols="12">
                <v-text-field
                    v-model="project.name"
                    filled
                    label="Name"
                    placeholder="Enter project name"
                    @keyup="onKeyUp"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                    v-model="project.slug"
                    filled
                    label="Slug"
                    placeholder="Nhập Slug"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                    v-model="project.order"
                    filled
                    label="Vị trí "
                    placeholder="Nhập vị trí"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-textarea
                    v-model="project.short_description"
                    filled
                    label="Short description"
                    placeholder="Enter short description"
                ></v-textarea>
              </v-col>
              <v-col cols="12">
                <div class="my-4">Description</div>
                <ck-content :content="project.description" class="ck-project"
                            @getData="value => project.description = value"></ck-content>
              </v-col>

              <!--ảnh avatar-->
              <v-col cols="12">
                <v-file-input
                    label="Ảnh avatar"
                    placeholder="Tải ảnh lên"
                    prepend-icon="mdi-camera"
                    v-model="imageAvatar"
                    @change="uploadImgAvatar"
                ></v-file-input>
                <div v-if="display_image_avatar">
                  <v-img
                      :src="display_image_avatar"
                      aspect-ratio="1.7"
                      contain width="200"
                  ></v-img>
                </div>
              </v-col>
              <!--ảnh cover-->
              <v-col cols="12">
                <v-file-input v-model="imageCover" label="Ảnh cover" laceholder="Tải ảnh lên" multiple
                              prepend-icon="mdi-camera" @change="uploadImgCover"></v-file-input>
                <div v-if="list_image_cover && list_image_cover.length>0">
                  <v-radio-group>
                    <v-row>
                      <v-col v-for="(img,index) in list_image_cover" :key="index" cols="3">
                        <v-row>
                          <v-col class="d-flex justify-center" cols="12">
                            <v-img
                                :src="img.url"
                                aspect-ratio="1.7"
                                contain
                            ></v-img>
                          </v-col>
                          <v-col class="d-flex justify-center" cols="12">
                            <v-btn
                                color="red"
                                fab
                                outlined
                                x-small
                                @click="clearImgCover(index)"
                            >
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-radio-group>
                </div>
              </v-col>
              <!-- ảnh screen-->
              <v-col cols="12">
                <v-file-input v-model="imageScreen" label="Ảnh Screen" laceholder="Tải ảnh lên" multiple
                              prepend-icon="mdi-camera" @change="uploadImgScreen"></v-file-input>
                <div v-if="list_image_screen && list_image_screen.length>0">
                  <v-radio-group>
                    <v-row>
                      <v-col v-for="(img,index) in list_image_screen" :key="index" cols="3">
                        <v-row>
                          <v-col class="d-flex justify-center" cols="12">
                            <v-img
                                :src="img.url"
                                aspect-ratio="1.7"
                                contain
                            ></v-img>
                          </v-col>
                          <v-col class="d-flex justify-center" cols="12">
                            <v-btn
                                color="red"
                                fab
                                outlined
                                x-small
                                @click="clearImgScreen(index)"
                            >
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-radio-group>
                </div>
              </v-col>

            </v-col>
            <v-col cols="6">
              <v-col cols="12">
                <v-text-field
                    v-model="project.name_vi"
                    filled
                    label="Tên"
                    placeholder="Nhập tên project "
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-select
                    v-model="project.field_project_id"
                    :items="fields"
                    filled
                    item-text="name"
                    item-value="id"
                    label="Loại project"
                ></v-select>
              </v-col>
              <v-col cols="12" style="margin-bottom: 86px"></v-col>
              <v-col cols="12">
                <v-textarea
                    v-model="project.short_description_vi"
                    filled
                    label="Mô tả ngắn"
                    placeholder="Nhập mô tả ngắn"
                ></v-textarea>
              </v-col>
              <v-col cols="12">
                <div class="my-4">Mô tả</div>
                <ck-content :content="project.description_vi" class="ck-project"
                            @getData="value => project.description_vi = value"></ck-content>
              </v-col>
              <!-- link-->
              <v-col cols="12">
                <v-row class="pl-3 py-3">
                  <h4 class="grey--text text--darken-4 text-decoration-underline">Link </h4>
                  <v-icon class="pl-1" @click="addLink">mdi-plus-box</v-icon>
                </v-row>
                <div v-for="(item, index) in list_link" :key="index">
                  <v-row class="mt-1" width="100%">
                    <v-col cols="3">
                      <v-text-field
                          v-model="item.type_link"
                          filled
                          label="Loại Link"
                          placeholder="Nhập loại link"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="7">
                      <v-text-field
                          v-model="item.link"
                          filled
                          label="Link"
                          placeholder="Nhập Link"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="2">
                      <v-btn class="btn-recycle rounded-lg" height="58" @click="clearBlock(index)">
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </div>
              </v-col>
              <v-col cols="12">
                <h4 class="mb-2">Project tags</h4>
                <v-divider></v-divider>
                <div>
                  <v-select
                      v-model="list_tag_id"
                      :items="list_tags"
                      chips
                      item-text="name"
                      item-value="id"
                      label="Tags"
                      multiple
                      outlined
                  ></v-select>
                </div>
              </v-col>

              <v-col cols="12">
                <v-text-field
                    v-model="project.phone"
                    filled
                    label="SĐT"
                    placeholder="Nhập SĐT"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                    v-model="project.email"
                    filled
                    label="Email"
                    placeholder="Nhập email"
                ></v-text-field>
              </v-col>
            </v-col>
          </v-row>
          <v-col class="d-flex justify-center" cols="12">
            <v-btn color="primary" elevation="6" width="180" @click="save" class="px-10">LƯU</v-btn>
          </v-col>
        </v-col>
      </v-row>


    </v-container>
  </v-col>
</template>

<script>
import CkContent from "@/components/ck-content"
import {GET_LIST_FIELD_PROJECT, UPLOAD_IMAGE, UPLOAD_LIST_IMAGE} from "@/store/modules/field_project";
import {mapGetters} from "vuex";
import {GET_LIST_TAGS} from "@/store/modules/tags";
import {SAVE_PROJECT} from "@/store/modules/project";
import validateSlug from "@/mixins/validateSlug";

export default {
  name: "Add_project",
  mixins: [validateSlug],
  components: {
    CkContent
  },
  data() {
    return {
      page: "Thêm project",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true,
        },
        {
          text: "Danh sách Projects",
          disabled: true,
        },
        {
          text: "Thêm project",
          disabled: false,
        },
      ],

      hasImage: false,

      list_tags: [],
      list_tag_id: [],
      project: {
        name: '',
        name_vi: '',
        slug: '',
        description: '',
        description_vi: '',
        field_project_id: '',
        link: '',
        photo_url: '',
        tags: [],
        photo_project: [],
        short_description: '',
        short_description_vi: '',
        phone: '',
        email: '',
        order: ''
      },
      //image Cover
      imageCover: null,
      list_image_cover: [],
      //image Avatar
      imageAvatar: null,
      display_image_avatar: '',
      //imageScreen
      imageScreen: null,
      list_image_screen: [],

      list_link: [],
      block_links: {
        type_link: '',
        link: ''
      }
    }
  },
  computed: {
    ...mapGetters({
      tags: "tags",
      fields: "fields",
    }),

  },
  watch: {
    tags(val) {
      if (val) {
        const _this = this
        val.forEach(el => {
          _this.list_tags.push({
            id: el.id,
            name: el.name,
          })
        })
      }
    },

  },

  async created() {
    await this.$store.dispatch(`${GET_LIST_TAGS}`);
    await this.$store.dispatch(`${GET_LIST_FIELD_PROJECT}`);
  },

  methods: {
    onKeyUp(value) {
      this.project.slug = this.sanitizeTitle(value.target.value)
    },
    uploadImgAvatar(e) {
      if (e) {
        this.display_image_avatar = URL.createObjectURL(e)
      }
      this.$forceUpdate()
    },

    uploadImgCover(e) {
      if (e)
        e.forEach((element, index) => {
          this.list_image_cover.push({
            'id': index,
            'url': URL.createObjectURL(element),
            'ob': element
          })
        });
      this.$forceUpdate()
    },
    clearImgCover(index) {
      this.list_image_cover.splice(index, 1)
      this.$forceUpdate()
    },
    uploadImgScreen(e) {
      if (e)
        e.forEach((element, index) => {
          this.list_image_screen.push({
            'id': index,
            'url': URL.createObjectURL(element),
            'ob': element
          })
        });
      this.$forceUpdate()
    },
    clearImgScreen(index) {
      this.list_image_screen.splice(index, 1)
      this.$forceUpdate()
    },
    addLink() {
      this.list_link.push({
            'type_link': this.block_links.type_link,
            'link': this.block_links.link
          }
      )
    },
    clearBlock(i) {
      this.list_link.splice(i, 1)
      this.$forceUpdate()
    },

    async save() {
      let formDateAvatar = new FormData();
      formDateAvatar.append("upload", this.imageAvatar);
      formDateAvatar.append("type", "ckeditor");
      formDateAvatar.append("position_type", "1");
      await this.$store.dispatch(`${UPLOAD_IMAGE}`, formDateAvatar).then((data) => {
            if (data.data.status == 1) {
              this.project.photo_url = data.data.data[0].path
            }
          }
      )

      let formData = new FormData();
      this.list_image_cover.forEach(e => {
        formData.append(`upload[]`, e.ob);
      })
      formData.append("type", "ckeditor");
      formData.append("position_type", "1");
      await this.$store.dispatch(`${UPLOAD_LIST_IMAGE}`, formData).then((data) => {
        if (data.data.status == 1) {
          data.data.data.forEach(e => {
            this.project.photo_project.push(e.media_id);
          })
        }
      });

      let formData1 = new FormData();
      this.list_image_screen.forEach(e => {
        formData1.append(`upload[]`, e.ob);
      })
      formData1.append("type", "ckeditor");
      formData1.append("position_type", "2");
      await this.$store.dispatch(`${UPLOAD_LIST_IMAGE}`, formData1).then((data) => {
        if (data.data.status == 1) {
          data.data.data.forEach(e => {
            this.project.photo_project.push(e.media_id);
          })
        }
      });

      const _this = this;
      //list tags
      this.list_tag_id.forEach(id => {
        let tag = _this.list_tags.find(el => el.id == id)
        _this.project.tags.push(tag.id
        )
      })
      let data = {
        name: this.project.name,
        name_vi: this.project.name_vi,
        slug: this.project.slug,
        short_description: this.project.short_description,
        short_description_vi: this.project.short_description_vi,
        field_project_id: this.project.field_project_id,
        link: JSON.stringify(this.list_link),
        photo_url: this.project.photo_url,
        tags: this.project.tags,
        photo_projects: this.project.photo_project,
        description: this.project.description,
        description_vi: this.project.description_vi,
        active: 0,
        phone: this.project.phone,
        email: this.project.email,
        order: this.project.order
      }
      await this.$store.dispatch(`${SAVE_PROJECT}`, data).then((data) => {
        if (data.data.status == 1) {
          this.$toasted.success('Cập nhật thành công!', {
            duration: 1000,
            position: 'top-center'
          })
          this.$router.push('/project_management/project')
        } else {
          alert(data.data.errors)
        }
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.technology {
  border: 1px solid #979797;
}

.btn-recycle {
  color: #6F6F71;
  border: 1px solid #9E9E9E;
}

.ck-project .ck-editor__main .ck-content {
  height: 140px;
}
</style>